// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__jYKvO","onlyWhite":"logo_onlyWhite__78TnJ"};